import { createSlice } from "@reduxjs/toolkit";
import { mapitShipApi } from "src/_api/mapitShipApi";

const slice = createSlice({
    name: "cities",
    initialState: {
        cities: [],
        loading: false,
        error: null
    },
    reducers: {
        setCities: (state, action) => {
            state.cities = action.payload;
        },
        clearCities: (state) => {
            state.cities = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                mapitShipApi.endpoints.getAllCities.matchPending,
                (state) => {
                    state.loading = true;
                    state.error = null;
                }
            )
            .addMatcher(
                mapitShipApi.endpoints.getAllCities.matchFulfilled,
                (state, { payload }) => {
                    state.cities = payload?.data || [];
                    state.loading = false;
                    state.error = null;
                }
            )
            .addMatcher(
                mapitShipApi.endpoints.getAllCities.matchRejected,
                (state, { payload }) => {
                    state.loading = false;
                    state.error = payload;
                }
            );
    }
});

export const { setCities, clearCities } = slice.actions;

export default slice.reducer;

// Selectors
export const selectCities = (state) => state.entities.cities.cities;
export const selectCitiesLoading = (state) => state.entities.cities.loading;
export const selectCitiesError = (state) => state.entities.cities.error;
